import React, { useState, useEffect } from 'react';
import { Form, Upload, Button, Icon, Input, Radio, Popover, Select, Tooltip, Checkbox, message } from 'antd';
import { BulkUploadBatch } from '../../../../models/batch';
import { Text1, Text4, Text5 } from '../../../../styles';
import { connect } from 'react-redux';
import { PROVIDER_PAYMENT_MODE_MESSAGES } from '../../../../constants';
import { QuickTransfer, Beneficiary } from '../../../../models';
import { getBankLogo } from '../../../../constants';
import { BATCHTYPES, bulkOperationsTypeMaster, bulkOperationsTemplateMaster } from '../../BulkUploadModal/constants';
import FileSaver from 'file-saver';
import { handleApiExceptions, isVirtualAccountVisible } from '../../../../app_methods';

const bulkupload = new BulkUploadBatch();

let BulkUploadForm = (props) => {
    const { form } = props;
    const { getFieldDecorator } = form;
    const validations = BulkUploadBatch.validations;
    const file = props.form.getFieldValue('file') || null;
    const virtual_accounts = props.current_user.virtual_accounts ?? []
    const virtual_account =  virtual_accounts.find((va) =>va.virtual_account_number === bulkupload.virtual_account_number) || {}
 
    const [selectedVirtualAccount, setSelectedVirtualAccount] = useState(props.type === "transfer" ? props.current_user.virtual_account : {});

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
            if (err) return;
            const selectedVirtualAccount = virtual_accounts.find(va => va.virtual_account_number === values.virtual_account_number);
            if (selectedVirtualAccount?.provider_code === "SBI") {
                message.warning("Only a single payment mode is allowed for SBI.");
                return;
            }
            props.onSubmit(form.getFieldsValue());
        });
    };

    const renderNotes = () => {
        const instructions = PROVIDER_PAYMENT_MODE_MESSAGES[props.current_user.virtual_account.provider_code] || {};
        const messages = Object.keys(instructions).map(payment_mode => instructions[payment_mode].node)
        let record_limit = 0
        if (props.batch_type == "beneficiary"){
            record_limit = props.current_user.bbul
        } else if(props.batch_type == "transfer"){
            record_limit = props.current_user.tbul
        } else if(props.batch_type == "instacollect_order"){
            record_limit = props.current_user.iobul
        } else if(props.batch_type == "penny_drop"){
            record_limit = props.current_user.bulk_penny_drop_upload_limit
        } else if(props.batch_type == "advanced_penny_drop"){
            record_limit = props.current_user.bulk_advanced_penny_drop_upload_limit
        }
        else if(props.batch_type == "payout_link"){
            record_limit = props.current_user?.payout_link_bulk_upload_limit || 0
        }
        return (
            <>
                {props.batch_type?<Text5 className="d-block">• Maximum { record_limit } records can be uploaded at a time.</Text5>:<Text5 className="d-block"> Please select batch type</Text5>}
                {
                    props.batch_type == "transfer" && messages.map(message => <Text5 className="d-block">• {message}</Text5>)
                }
            </>
        )
    };

    const renderThresholdPercentLabelIcon = () => {
        return (
          <div className="d-inline-flex m-0 align-items-center">
            Match Percentage Threshold
            <Tooltip placement="right" title={`If not provided, match percentage threshold will be considered as ${props?.current_user?.fuzzy_check_threshold_percentage}%`}>
              <Icon style={{color: "#1890ff"}} className="ml-2" type="exclamation-circle" />
            </Tooltip>
          </div>
        );
      };


    const handleVirtualAccountChange = (value) => {
        const selectedVA = props.current_user.virtual_accounts.find(
            (va) => va.virtual_account_number === value
          );
          
        setSelectedVirtualAccount(selectedVA);
    }

    const downloadTemplate = async () => {
            const response = await BulkUploadBatch.downloadTemplate({
                batch_type: props.uploadType,
                virtual_account_number: selectedVirtualAccount?.virtual_account_number,
              });
    
            if (!response) {
                handleApiExceptions("Something went wrong !");
                return;
            }
            FileSaver.saveAs(response.data, bulkOperationsTemplateMaster[props.uploadType]);
        };

    return (
        <Form onSubmit={onSubmit}>
            <Form.Item>
                {getFieldDecorator("queue_on_low_balance", {
                    initialValue: props.merchant.eqlb
                })(<Input autoComplete='off' hidden />)}
                {getFieldDecorator("batch_type", {
                    initialValue: props.batch_type
                })(<Input autoComplete='off' type="hidden" />)}
            </Form.Item>
            {props.batch_type==="transfer"?
                <Form.Item label="Source Virtual Account">
                {getFieldDecorator("virtual_account_number", {
                    rules: QuickTransfer.validations.virtual_account_number,
                    initialValue: isVirtualAccountVisible(props.current_user.virtual_account) && props.current_user.virtual_account.virtual_account_number
                })(<Select onChange={handleVirtualAccountChange}>
                    {
                        props.current_user.virtual_accounts.filter(va => va.status == "active" && isVirtualAccountVisible(va)).map((va, index) => {
                            return (
                                <Select.Option value={va.virtual_account_number} disabled={va.funding_via==2 && !props.current_user.allow_payouts_via_cc_va? true : false}>
                                    <div className="d-flex">
                                        <div
                                            style={{
                                                display: "flex",
                                                width: 28,
                                                overflow: "hidden",
                                                textAlign: "center",
                                                marginRight: 8
                                            }}
                                        >
                                            <img
                                                style={{
                                                    margin: "auto",
                                                    width: "auto",
                                                    maxWidth: "100%",
                                                    maxHeight: 28
                                                }}
                                                alt=""
                                                src={getBankLogo(va.provider_code)}
                                            />
                                        </div>
                                        <Text4 className="mr-1">{va.label}</Text4>
                                    </div>
                                </Select.Option>
                            )
                        })
                    }
                </Select>)}
                </Form.Item>
            :null}

            <div style={{ marginBottom: "15px" }}>
                {props.showBatchType ? (
                    <div className="mt-2">
                        <Text1 className="d-block mb-2" strong>
                            {props.bulkUploadModalType}
                        </Text1>
                        <Text4 className="d-block" strong>
                            Select batch type:
                        </Text4>
                        <Select
                            placeholder="Select batch type"
                            className="w-100"
                            onChange={(e) => props.setUploadType(e)}
                        >
                            {BATCHTYPES.map((batch) => {
                                return (
                                    props.current_user &&
                                    props.current_user[batch.required_setting] &&
                                    props.current_user.user.permissions.includes(batch.required_permission) && (
                                        <Select.Option value={batch.value}>
                                            <div className="d-flex">
                                                <Text4 className="mr-1">{batch.key}</Text4>
                                            </div>
                                        </Select.Option>
                                    )
                                );
                            })}
                        </Select>
                        {!props.uploadType ? null : (
                            <Text4 className="d-flex justify-content-end mt-1 mb-2" type="secondary">
                                <a onClick={downloadTemplate} className="color-link">
                                    Download Template
                                </a>
                            </Text4>
                        )}
                    </div>
                    ) : (
                        <Text4 className="d-block" type="secondary">
                            <a onClick={downloadTemplate} className="color-link">
                                Click here
                            </a>{" "}
                            to download "{bulkOperationsTypeMaster[props.type]}" excel file template.
                        </Text4>
                    )}
            </div>
                
            <Form.Item label="Batch Name">
                {getFieldDecorator('name', {
                    rules: validations.name
                })(<Input autoComplete='off' />)}
            </Form.Item>

            <Form.Item>
                {getFieldDecorator('file', {
                    valuePropName: 'file',
                    rules: validations.file
                })(
                    <Upload.Dragger
                        name='file'
                        multiple={false}
                        showUploadList={false}
                        className="pl-0 pb-2 d-block"
                        beforeUpload={(file) => {
                            return false;
                        }}
                    >
                        <p className="ant-upload-drag-icon"><Icon type="inbox" /></p>
                        {
                            file ? (
                                <div>
                                    <Text4 strong>Selected File:</Text4>
                                    <Text4 className="ml-2">
                                        {(file || {}).fileList[(file || {}).fileList.length - 1].name}
                                    </Text4>
                                </div>
                            ) : <div>
                                    <Text4 className="d-block">Click or drag file to this area to upload</Text4>
                                </div>
                        }
                    </Upload.Dragger>
                )}
            </Form.Item>
            {props.batch_type === "advanced_penny_drop" && 
                <Form.Item label={renderThresholdPercentLabelIcon()}>
                    {getFieldDecorator('threshold_percentage', {
                        rules: validations.threshold_percentage
                    })(<Input autoComplete='off' />)}
                </Form.Item>
            }
            {props?.batch_type === "transfer" && 
                <Form.Item >
                    {getFieldDecorator('continue_on_error', {
                        rules: validations.continue_on_error
                    })(
                        <div>
                            <Checkbox>Bypass Validation Errors
                                <Tooltip placement="right" title={`Enabling this will skip the error checks and process the file`}>
                                    <Icon  className='mx-2' type="info-circle"/>
                                </Tooltip>
                            </Checkbox>                       
                        </div>
                    )
                    }
                </Form.Item>
            }

            {/* { props.batch_type == "beneficiary" && props.current_user?.merchant_active_on_sbi ?
                    <Form.Item >
                    {getFieldDecorator("onboard_on_sbi", {
                        initialValue: false,
                        valuePropName: "checked"
                    })(<Checkbox autoFocus >Add as SBI Beneficiary</Checkbox>)}
                </Form.Item>:null
            } */}
            
            <div className="w-100 d-flex justify-content-between mt-4">
                <Popover
                    overlayStyle={{ maxWidth: 600 }}
                    content={renderNotes()}
                    placement="top"
                    trigger="click"
                >
                    <Button className="pl-0" type="link">Notes</Button>
                </Popover>
                <Button type="primary" htmlType="submit" loading={props.loading}>{props.submitText || "Submit"}</Button>
            </div>
        </Form>
    )
};

BulkUploadForm = Form.create()(BulkUploadForm);

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

BulkUploadForm = connect(mapStateToProps, null)(BulkUploadForm);

export { BulkUploadForm };